export const baseUrl = "https://myadmin.provoltus.com/api/v1/";
export const categories = "categories";
export const categoryDetails = "category/";
export const contactInfo = "save/contact/info";
export const Galleries = "galleries";
export const Products = "products";
export const productEnquiry = "save/product/enquiry";
export const Sponsers = "sponsors";